"use client";

import { create } from "zustand";
import { persist } from "zustand/middleware";

type ReuploadImagesState = {
  reuploadImagesOnPatch: boolean;
  setReuploadImagesOnPatch: (value: boolean) => void;
};

export const useReuploadImagesStore = create<ReuploadImagesState>()(
  persist(
    (set) => ({
      reuploadImagesOnPatch: false,
      setReuploadImagesOnPatch: (value) =>
        set({ reuploadImagesOnPatch: value }),
    }),
    { name: "reupload-images-storage" },
  ),
);

export const shouldReuploadImagesOnPatch = () =>
  useReuploadImagesStore.getState().reuploadImagesOnPatch;
